export function loadGoogleMaps(apiKey, libraries = "places") {
  const scriptId = "google-maps";
  const existingScript = document.getElementById(scriptId);

  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google);
      return;
    }

    if (existingScript) {
      // Wait for maps to load
      const checkReady = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(checkReady);
          resolve(window.google);
        }
      }, 50);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries}&loading=async`;
    script.id = scriptId;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      const checkReady = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(checkReady);
          resolve(window.google);
        }
      }, 50);
    };

    script.onerror = reject;
    document.head.appendChild(script);
  });
}